export default function Plans() {
  return <div></div>;
}
